module.exports = __webpack_public_path__ + "img/espace_perso_mobile.b991b20c.jpg";